import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDrops = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 18,
	fill: "none",
	viewBox: "0 0 17 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "#18a0fb",
		strokeLinecap: "round",
		strokeWidth: 1.46648,
		d: "M13.1359 2.40566c.0307-.63115-.1406-1.845111-1.0713-1.651796-1.1633.241644.5297 4.888136 1.0713 1.651796ZM5.79479 6.62205c-.42322-.4356-1.37816-1.14163-1.81213-.48089-.54247.82592 3.74729 2.93441 1.81213.48089ZM4.13767 16.9539c.60643-.0332 1.76593-.29 1.55245-1.0512-.26686-.9514-4.67363.9001-1.55245 1.0512Z"
	})
});
export default SvgDrops;
